function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M50.4725 83V48.44L79.4325 83H90.1525V29.64H77.8325V64.04L48.8725 29.64H38.1525V83H50.4725ZM128.464 28.44C117.824 28.44 111.184 32.68 107.584 36.28C102.784 41.08 99.3444 48.84 99.3444 56.52C99.3444 64.36 102.544 71.56 107.664 76.36C111.664 80.2 118.464 84.2 128.464 84.2C137.424 84.2 144.144 81.16 149.104 76.36C154.864 70.76 157.424 63.48 157.424 56.36C157.424 48.12 154.144 41.08 149.104 36.2C143.744 31 136.784 28.44 128.464 28.44ZM128.384 39.8C133.264 39.8 137.504 41.8 140.144 44.36C142.544 46.76 144.784 50.84 144.784 56.36C144.784 62.52 142.224 66.28 140.144 68.28C137.584 70.84 133.744 72.84 128.304 72.84C124.144 72.84 120.304 71.72 116.864 68.44C113.584 65.24 111.984 61.32 111.984 56.44C111.984 50.52 114.384 46.6 116.704 44.36C119.584 41.48 123.744 39.8 128.384 39.8ZM166.59 29.64V83H178.91V64.28H186.43C190.19 64.28 195.79 63.88 200.03 59.56C202.03 57.48 204.59 53.72 204.59 47C204.59 43.32 203.95 38.04 199.39 34.04C195.15 30.28 190.03 29.64 185.39 29.64H166.59ZM178.91 39.72H183.07C185.47 39.72 188.11 39.96 189.95 41.72C191.15 42.84 191.95 44.68 191.95 46.92C191.95 49.24 191.07 51.08 189.95 52.2C187.95 54.12 184.99 54.2 183.31 54.2H178.91V39.72ZM242.531 29.64H212.371V83H242.531V72.6H224.691V60.76H241.651V50.36H224.691V40.04H242.531V29.64Z",
  fill: "#FF3575"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 6,
  width: 267,
  height: 100,
  rx: 10,
  stroke: "#FF3575",
  strokeWidth: 12
});

function SvgDiscard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 279,
    height: 112,
    viewBox: "0 0 279 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscard);
export default __webpack_public_path__ + "static/media/Discard.96b62693.svg";
export { ForwardRef as ReactComponent };